// extracted by mini-css-extract-plugin
export var completionBody = "_dh-2";
export var completionCard = "_dh-0";
export var completionFooter = "_dh-3";
export var completionTitle = "_dh-1";